var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconawesomeUserAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.747,
    height: 15.747,
    viewBox: "0 0 15.747 15.747",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-alt",
    "data-name": "Icon awesome-user-alt",
    d: "M7.873,8.858A4.429,4.429,0,1,0,3.445,4.429,4.43,4.43,0,0,0,7.873,8.858Zm3.937.984H10.116a5.354,5.354,0,0,1-4.484,0H3.937A3.936,3.936,0,0,0,0,13.779v.492a1.477,1.477,0,0,0,1.476,1.476H14.271a1.477,1.477,0,0,0,1.476-1.476v-.492A3.936,3.936,0,0,0,11.81,9.842Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomeUserAlt);
export default __webpack_public_path__ + "static/media/IconawesomeUserAlt.344722b662c87187f141432a57dfa811.svg";
export { ForwardRef as ReactComponent };